import React from 'react';

/**
 * Skeleton — shimmer placeholder (DESIGN-SPEC §3.8).
 *
 * Renders a slate-tinted shimmer block via the `.skeleton` utility
 * (linear-gradient sweep + `shimmer` keyframe, defined in index.css
 * `@layer components`). Under `prefers-reduced-motion: reduce` the
 * sweep is neutralised to a static grey block by the same CSS rule.
 *
 * Dimensions are supplied by the caller through `className`
 * (e.g. "h-4 w-32 rounded-md") so each skeleton matches its final
 * layout box and avoids CLS. Used by App.jsx fallback, Dashboard,
 * StudyLibrary, Quizzes and the empty demo mockup.
 *
 * Decorative by nature → aria-hidden so screen readers skip it.
 *
 * @param {{ className?: string }} props
 */
export default function Skeleton({ className = '' }) {
  return (
    <span
      aria-hidden="true"
      className={`skeleton block ${className}`}
    />
  );
}
